import { render } from 'preact';
import { Workbox } from 'workbox-window';
import { App } from './app';
import './styles/tokens.css';
import './styles/global.css';
import './styles/item-edit-list.css';
import './styles/capture-flow.css';
import './styles/review.css';
import './styles/phone-layout.css';

/**
 * PWA entry. Mounts the app and registers the Workbox service worker.
 * The SW is best-effort — the PWA still works without it.
 *
 * v0 NOTE: src/service-worker.ts uses Workbox's `__WB_MANIFEST` placeholder
 * for precaching, which requires either `workbox-build` or `vite-plugin-pwa`
 * to inject the manifest at build time. That plugin wiring is a follow-up
 * before first deploy. Until then, registration is gated by a flag so we
 * don't 404 on `/service-worker.js` in production. Set
 * `VITE_ENABLE_SW=true` in the env once the plugin is wired.
 */
// Same cast pattern as src/lib/api.ts — the tsconfig doesn't pull in
// vite/client types, so import.meta.env is typed locally.
const swEnabled =
  ((import.meta as ImportMeta & { env?: Record<string, string> }).env?.VITE_ENABLE_SW ?? '') === 'true';
if (swEnabled && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const wb = new Workbox('/service-worker.js');
    wb.addEventListener('waiting', () => {
      // A new SW is waiting. We don't auto-skip-waiting; the app will pick
      // it up on next reload.
    });
    wb.register().catch(() => {
      // ignore — offline support is best-effort
    });
  });
}

const root = document.getElementById('app');
if (root) render(<App />, root);
